/* NUBO · Homepage corporativa · v2 (sin dependencias)
   Cada sección NUBO incluye este archivo; la guarda evita que corra dos veces. */
(function () {
  'use strict';
  if (window.__nuboHome) return;
  window.__nuboHome = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);

  function pad(n) { return ('0' + n).slice(-2); }

  function splitWords(h) {
    if (h.__nbSplit) return;
    h.__nbSplit = true;
    var n = 0;
    (function walk(node) {
      [].slice.call(node.childNodes).forEach(function (c) {
        if (c.nodeType === 3) {
          var parts = c.textContent.split(/(\s+)/), frag = document.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span'); w.className = 'nb-w';
            var i = document.createElement('span'); i.className = 'nb-w__i'; i.style.setProperty('--i', n++); i.textContent = p;
            w.appendChild(i); frag.appendChild(w);
          });
          node.replaceChild(frag, c);
        } else if (c.nodeType === 1 && c.tagName !== 'BR') { walk(c); }
      });
    })(h);
    if (!h.closest('[data-nb-reveal]')) h.setAttribute('data-nb-reveal', 'words');
  }

  function init(root) {
    if (!root || root.__nbInit) return;
    root.__nbInit = true;
    root.classList.add('nb-js');

    /* Títulos: cada palabra sube desde una máscara */
    if (!reduce && !design) root.querySelectorAll('.nb-h2').forEach(splitWords);

    /* Revelado al hacer scroll (en el editor de temas se muestra todo de inmediato) */
    var reveal = [].slice.call(root.querySelectorAll('[data-nb-reveal], .nb-hero'));
    /* Si la página se abrió en segundo plano, IntersectionObserver no avisa hasta que se ve: se muestra todo */
    if (reduce || design || document.visibilityState === 'hidden' || !('IntersectionObserver' in window)) {
      reveal.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      /* Respaldo: lo que ya está en pantalla nunca queda oculto más de 2,5 s */
      setTimeout(function () {
        reveal.forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in'); });
      }, 2500);
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
      reveal.forEach(function (el) { io.observe(el); });
    }

    /* Detalles: la imagen fija cambia según el punto activo */
    var feats = [].slice.call(root.querySelectorAll('.nb-feature'));
    var frames = [].slice.call(root.querySelectorAll('.nb-features__frame'));
    var counter = root.querySelector('[data-nb-count]');
    function activate(i) {
      frames.forEach(function (f, k) { f.classList.toggle('is-active', k === i); });
      feats.forEach(function (f, k) { f.classList.toggle('is-active', k === i); });
      if (counter) counter.textContent = pad(i + 1) + ' / ' + pad(feats.length);
    }
    root.__nbActivate = activate;
    if (feats.length) {
      activate(0);
      if ('IntersectionObserver' in window) {
        var fio = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) activate(+en.target.getAttribute('data-index')); });
        }, { rootMargin: '-42% 0px -42% 0px' });
        feats.forEach(function (f) { fio.observe(f); });
      }
    }

    /* Carrusel de productos */
    root.querySelectorAll('[data-nb-rail]').forEach(function (rail) {
      var list = rail.querySelector('.nb-rail__list');
      var btns = rail.querySelectorAll('[data-dir]');
      if (!list) return;
      function step() {
        var card = list.querySelector('.nb-card');
        var gap = parseFloat(getComputedStyle(list).columnGap) || 24;
        return card ? card.getBoundingClientRect().width + gap : 320;
      }
      function update() {
        var max = list.scrollWidth - list.clientWidth - 4;
        btns.forEach(function (b) {
          var dir = +b.getAttribute('data-dir');
          b.disabled = dir < 0 ? list.scrollLeft <= 4 : list.scrollLeft >= max;
        });
      }
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          list.scrollBy({ left: step() * +b.getAttribute('data-dir'), behavior: reduce ? 'auto' : 'smooth' });
        });
      });
      list.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });

    /* Parallax suave (solo escritorio). data-nb-parallax va en el marco; se mueve la imagen de adentro */
    if (!reduce) {
      var px = [].slice.call(root.querySelectorAll('[data-nb-parallax]'));
      var ticking = false;
      var run = function () {
        ticking = false;
        var desktop = window.innerWidth >= 900;
        px.forEach(function (box) {
          var img = box.tagName === 'IMG' ? box : box.querySelector('img');
          if (!img) return;
          if (!desktop) { img.style.translate = ''; img.style.transform = ''; return; }
          var r = (box.tagName === 'IMG' ? box.parentElement : box).getBoundingClientRect();
          if (r.bottom < -200 || r.top > window.innerHeight + 200) return;
          var speed = parseFloat(box.getAttribute('data-nb-parallax')) || 0.06;
          var scale = 1 + speed * 1.6;
          var room = (scale - 1) / 2 * r.height - 1;          /* margen que deja la ampliación */
          var off = (r.top + r.height / 2 - window.innerHeight / 2) * -speed;
          off = Math.max(-room, Math.min(room, off));
          img.style.transform = 'scale(' + scale.toFixed(3) + ')';
          img.style.translate = '0 ' + off.toFixed(1) + 'px';
        });
      };
      if (px.length) {
        window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
        window.addEventListener('resize', run);
        run();
      }
    }

    /* Pausar la marquesina (WCAG 2.2.2) */
    root.querySelectorAll('[data-nb-pause]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var on = btn.getAttribute('aria-pressed') !== 'true';
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.setAttribute('aria-label', on ? 'Reanudar animación' : 'Pausar animación');
        root.classList.toggle('nb-paused', on);
      });
    });

  }

  function boot() { document.querySelectorAll('.nb').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* Editor de temas de Shopify */
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.nb');
    if (r) { r.__nbInit = false; init(r); }
  });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target, root = el.closest && el.closest('.nb');
    if (!root) return;
    if (el.classList.contains('nb-feature') && root.__nbActivate) root.__nbActivate(+el.getAttribute('data-index'));
    if (el.classList.contains('nb-card')) el.scrollIntoView({ block: 'nearest', inline: 'start' });
    if (el.tagName === 'DETAILS') el.open = true;
  });
})();
